import { buildUpstreamHasFlagValidator } from './upstreamHasFlagValidator.builder';

buildUpstreamHasFlagValidator('providesRepositoryInformation', 'repositoryInformationProvided');
